var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColdemail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 80,
    viewBox: "0 0 100 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2586_67162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V79.8889H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2586_67162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66888 30.9171L94.2592 0.944919C97.4258 -0.110636 100.37 3.02825 99.1272 6.12548L71.8564 73.8477C70.5994 76.9727 66.8217 78.1949 63.9744 76.4033L45.1481 64.5491L34.1481 77.313C31.7383 80.0977 27.1689 78.3963 27.1689 74.7158V53.2296L52.6133 34.6741C53.905 33.7296 52.7314 31.7366 51.28 32.3963L18.1619 47.563L2.81471 37.9033C0.0299926 36.1533 0.54388 31.9449 3.66888 30.9171Z",
    fill: "#FF3301"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdemail);
export default __webpack_public_path__ + "static/media/coldemail.c3da121efb311d82a8a900f801208db7.svg";
export { ForwardRef as ReactComponent };